import React, { useState } from "react";
import { resendVerification } from "../../utils/api";

export default function ResendVerification() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await resendVerification(email);
      setMsg("If the email exists, a verification link has been sent.");
    } catch {
      setMsg("Something went wrong.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Resend Verification Email</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button type="submit">Send Verification Again</button>
      </form>

      {msg && <p>{msg}</p>}
    </div>
  );
}
